import React from 'react';
import SmartUSDXX from '../components/updated/SmartUSDXX';

const SmartUSDXXPage = () => {
  return (
    <div>
      <SmartUSDXX />
    </div>
  );
};

export default SmartUSDXXPage;
